import moment from 'moment'
import React from 'react'
import DatePicker from "react-datepicker"
import {Link} from 'react-router-dom'
import Text from 'react-text'
import ScheduleComment from '../schedule-comment'
import {faChevronRight, faChevronLeft, faCalendarAlt, faComment, faPlusCircle} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {Consumer} from '../../context'
import CalendarAltInput from "../date-picker/calendar-alt-input"

import './toolbar.styl'

function changeDate ({navigate, match}, view) {
  const pad = view == 'day' ? 'day' : 'week'
  return (date) => {
    const query = {
      start: moment(date).startOf(view).startOf(pad).format('YYYY-MM-DD'),
      end: moment(date).endOf(view).endOf(pad).format('YYYY-MM-DD')
    }
    navigate({}, match.path, {preserveQuery: true, query})
  }
}

export function changeView ({navigate, match}) {
  return (view, query) => {
    navigate({view}, match.path, {preserveQuery: true, query})
  }
}

function title (date, level, {translate, languageId}) {
  switch (level) {
    case 'week':
      const start = moment(date).startOf(level).format('DD')
      const end = moment(date).endOf(level).format('DD')
      return `${translate('week_label')} ${start} - ${end}`
    case 'day':
      const formats = {
        es: "dddd, DD [de] MMMM [de] YYYY",
        en: "dddd, MMMM do YYYY"
      }
      return moment(date).format(formats[languageId])
    default:
      return moment(date).format('MMMM YYYY')
  }
}

export default function Toolbar (props) {
  const {date} = props
  const weekQuery = {
    start: moment(date()).startOf('week').format('YYYY-MM-DD'),
    end: moment(date()).endOf('week').format('YYYY-MM-DD')
  }
  const monthQuery = {
    start: moment(date()).startOf('month').format('YYYY-MM-DD'),
    end : moment(date()).endOf('month').format('YYYY-MM-DD')
  }
  const level = `${props.view}s`

  return (<Consumer>{ context => {
    const {languageId} = context
    const navigate = changeDate(context, props.view) 
    const navigateToView = changeView(context)
    const previous = () => navigate(date().subtract(1, level))
    const next = () => navigate(date().add(1, level))
    return (
      <div className="toolbar">
        <div className="navigation">
          <div className="previous" onClick={previous}>
            <div style={{display: 'flex', justifyContent: 'center'}}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </div>
          </div>
          <div className="icon">
            <DatePicker
              selected={moment(date()).toDate()}
              dateFormat="MM/yyyy"
              locale={languageId}
              popperPlacement="top-end"
              popperModifiers={{
                offset: {
                  enabled: true,
                  offset: props.view == 'month' ? "158px, 5px" : "180px, 5px"
                },
                preventOverflow: {
                  enabled: true,
                  escapeWithReference: false,
                  boundariesElement: 'viewport'
                },
              }}
              onChange={date => {navigate(moment(date))}}
              customInput={<CalendarAltInput />}
              showMonthYearPicker={props.view == 'month'}
            />
          </div>
          <div className="next" onClick={next}>
            <div style={{display: 'flex', justifyContent: 'center'}}>
              <FontAwesomeIcon icon={faChevronRight} />
            </div>
          </div>
        </div>
        <div className="title">
          {title(date(), props.view, context)}
        </div>
        <div className="button today" onClick={() => navigate(new Date())}>
          <Text id="today_label" />
        </div>
        <div
          className={`button week ${props.view == 'week' ? 'active' : ''}`}
          onClick={() => props.view != 'week' && navigateToView('week', weekQuery)}
        >
          <Text id="week_label" />
        </div>
        <div
          className={`button month ${props.view == 'month' ? 'active' : ''}`}
          onClick={() => props.view != 'month' && navigateToView('month', monthQuery)}
        >
          <Text id="month_label" />
        </div>
        {context.action == 'comment' && (<ScheduleComment selectedGroup={{}} activeTab='groups' />)}
        <Link
          className="add-comment"
          title={context.translate('add-comment')}
          to={context.link({action: 'comment', view: props.view}, '/:languageId/:role/:page/:view/:action', {preserveQuery: true})}
        >
          <div className="circle">
            <div className="comment-icon">
              <FontAwesomeIcon icon={faComment} />
            </div>
          </div>
          <div className="plus-icon">
            <FontAwesomeIcon icon={faPlusCircle} />
          </div>
        </Link>
      </div>
    )}}</Consumer>)
}
